import { FC, ReactNode } from "react";
import StatusTable from "./index";
import { useTranslation } from "react-i18next";
// import CTA from "@/components/atoms/CTA";
// import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
// import Tag from "@/components/atoms/Tag";
// import Rating from "@/components/atoms/Rating";
// import dayjs from "dayjs";

interface Props {
  feedbackData: any[];
  openDrawerHandler: (item: any) => void;
}

const AdminFeedbackTable: FC<Props> = ({ feedbackData: _f, openDrawerHandler: _o }) => {
  const { t } = useTranslation();

  const tableHeaders: string[] = [
    "",
    t("commonAdmin:postedAt"),
    t("commonAdmin:comment"),
    t("commonAdmin:rating"),
    t("commonAdmin:status"),
    t("commonAdmin:receiverCompanyId"),
    t("commonAdmin:senderCompanyId"),
    t("commonAdmin:process"),
  ];

  const tableRows: ReactNode[][] = []; // FeeedbackData is returning HTML not an array anymore. backend issue;
  // const tableRows: ReactNode[][] = feedbackData && feedbackData?.map((item, idx) => [
  //   <SVGAsset name="yellow-exclamation" key={idx} />,
  //   dayjs(item.postedAt).format("MMMM Do YYYY, HH:mm"),
  //   item.comment,
  //   <Rating rating={item.rating.substr(1, 1)} key={idx} />,
  //   <Tag status="REQUIRES_ACTION" key={idx}>
  //     {t("enumerables:orderStatus.AWAITING_ACTION")}
  //   </Tag>,
  //
  //   item.receiverCompanyId,
  //   item.senderCompanyId,
  //   <CTA onClick={() => openDrawerHandler(item)} size="sm" intent="secondary" key={idx}>
  //     {t("commonAdmin:process")}
  //   </CTA>,
  // ]);

  return (
    <StatusTable
      tableHeaders={tableHeaders}
      tableRows={tableRows ?? []}
      statusIndex={4}
      accordionTriggerContentIndices={[0, 1]}
      accordionBorderStyle="warn"
      lastChildIsCta={true}
    />
  );
};

export default AdminFeedbackTable;
